import React from 'react'

export default (({record, name}) => {
  return record.url ? (
    <a href={record.url} target={'_blank'} rel="noopener noreferrer">
      {name ? name : 'url 이동'}
    </a>
  ) : ''
})
